import styled from 'styled-components';

import { styledReset, styledTypography } from '../styles';

export const PrimitiveInputText = styled.input`
    ${styledReset.input};
    ${styledTypography.allianceBase};

    &:disabled {
        cursor: not-allowed;
    }

    &:read-only {
        ${styledTypography.truncate};
    }

    &[type='search'] {
        ${styledReset.inputSearchSubset};
    }
`;
